// Wine list — extracted from "Carte AnciennePoste v11" (latest version, Feb 2026).
// Re-organised by COLOR first (Champagnes & Bulles → Rosés → Blancs → Rouges)
// then by sub-region for fast scanning.
//
// Each bottle: { domain, cuvee?, appellation?, year?, bio?, magnum? }

export const WINES_BY_COLOR = {
  champagne: [
    {
      subregion: "Champagne",
      wines: [
        { domain: "Deutz", cuvee: "Brut Classic", appellation: "Champagne" },
        { domain: "Deutz", cuvee: "Blanc de Blancs Millésimé", appellation: "Champagne", year: 2020 },
        { domain: "Philipponnat", cuvee: "Réserve Perpétuelle Brut", appellation: "Champagne" },
        { domain: "Philipponnat", cuvee: "Rosé Brut", appellation: "Champagne Rosé" },
        { domain: "Bollinger", cuvee: "Spéciale Cuvée Brut", appellation: "Champagne" },
      ],
    },
    {
      subregion: "Pétillants Naturels",
      wines: [
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Éclats des Bulles »", appellation: "Vin de France · Pet'Nat", year: 2025, bio: true },
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Fun en Bulles »", appellation: "Vin de Table Pétillant", year: 2025 },
      ],
    },
  ],

  rose: [
    {
      subregion: "Vallée du Rhône — Sud",
      wines: [
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Cuvée Ninon »", appellation: "AOC Ventoux" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Versant Sud »", appellation: "AOC Côtes du Rhône" },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Éphémère »", appellation: "AOP Ventoux", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Luberon",
      wines: [
        { domain: "Domaine de Maslauris", cuvee: "« L'Inopiné »", appellation: "AOP Luberon", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Provence",
      wines: [
        { domain: "Domaine Saint André de Figuière — Famille Combard", cuvee: "« Première »", appellation: "AOP Côtes de Provence", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Vins doux — Muscat",
      wines: [
        { domain: "Vignoble Alain Ignace", cuvee: "Muscat Rosé", appellation: "Beaumes-de-Venise", year: 2025 },
      ],
    },
  ],

  blanc: [
    // === Vallée du Rhône — Sud ===
    {
      subregion: "Ventoux",
      wines: [
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« La Beaume »", appellation: "AOC Ventoux", year: 2024 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Tradition »", appellation: "AOP Ventoux", year: 2025, bio: true },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Les Gressannes »", appellation: "AOP Ventoux", year: 2024, bio: true },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Argile »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Les Safres »", appellation: "AOP Ventoux", year: 2025, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Genêt joli »", appellation: "AOP Ventoux", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Côtes du Rhône",
      wines: [
        { domain: "Domaine Talès — Entrechaux", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Versant Sud »", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "Cuvée traditionnelle", appellation: "AOC Côtes du Rhône", year: 2025, bio: true },
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "« Les Champauvins »", appellation: "AOC Côtes du Rhône", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Côtes du Rhône Villages",
      wines: [
        { domain: "Coteaux des Travers — Rasteau", cuvee: "« Marine »", appellation: "AOC Cairanne", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Vacqueyras",
      wines: [
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "Cuvée traditionnelle", appellation: "AOC Vacqueyras", year: 2024, bio: true },
        { domain: "Alain Jaume", cuvee: "« Grande Garrigue »", appellation: "AOC Vacqueyras", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Gigondas",
      wines: [
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« La Quintessence »", appellation: "AOC Gigondas", year: 2024 },
      ],
    },
    {
      subregion: "Châteauneuf-du-Pape",
      wines: [
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "« La Fontaine »", appellation: "AOC Châteauneuf-du-Pape", year: 2024, bio: true },
      ],
    },
    {
      subregion: "Luberon",
      wines: [
        { domain: "Domaine de Maslauris", cuvee: "« L'Inopiné »", appellation: "AOP Luberon", year: 2024, bio: true },
      ],
    },
    {
      subregion: "IGP & Vin de France",
      wines: [
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "Viognier", appellation: "IGP Vaucluse", year: 2025, bio: true },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "« Tire Bouchon »", appellation: "IGP Vaucluse", year: 2024, bio: true },
        { domain: "Domaine Les Chancel — Mormoiron", cuvee: "« N°1 »", appellation: "IGP Vaucluse", year: 2023, bio: true },
        { domain: "Domaine Les Chancel — Mormoiron", cuvee: "« Le Récit »", appellation: "Vin de France", year: 2022, bio: true },
      ],
    },
    // === Vallée du Rhône — Nord ===
    {
      subregion: "Vallée du Rhône — Nord",
      wines: [
        { domain: "Alain Jaume — « La Butte d'Or »", appellation: "AOC Condrieu", year: 2024 },
      ],
    },
    // === Bourgogne ===
    {
      subregion: "Bourgogne — Chablis",
      wines: [
        { domain: "Domaine Sébastien Dampt", cuvee: "« Les Vaillons » 1er Cru", appellation: "AOC Chablis 1er Cru", year: 2023 },
        { domain: "Domaine Julie Fèvre", appellation: "AOC Chablis", year: 2024 },
        { domain: "Domaine Julie Fèvre", cuvee: "« Les Preuses » Grand Cru", appellation: "AOC Chablis Grand Cru", year: 2023 },
      ],
    },
    {
      subregion: "Bourgogne — Côte de Nuits",
      wines: [
        { domain: "Jouan Olivier", cuvee: "Village", appellation: "AOC Bourgogne Hautes-Côtes de Nuits", year: 2023 },
      ],
    },
    {
      subregion: "Bourgogne — Côte de Beaune",
      wines: [
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "Chardonnay", appellation: "AOC Bourgogne Côte d'Or", year: 2022 },
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "« Clos Saint-Désirée »", appellation: "AOC Beaune", year: 2023 },
        { domain: "Baillot Arnaud", cuvee: "« À Ma Fille Mahaut »", appellation: "AOC Pernand-Vergelesses", year: 2023 },
        { domain: "Domaine Larue — Saint-Aubin", cuvee: "« Les Champlots » 1er Cru", appellation: "AOC Saint-Aubin 1er Cru", year: 2023 },
        { domain: "Domaine Alain Gras — Saint-Romain", cuvee: "« Cinq Climats »", appellation: "AOC Saint-Romain", year: 2024 },
        { domain: "Domaine Alain Gras — Saint-Romain", cuvee: "« Sous le Château »", appellation: "AOC Saint-Romain", year: 2023, magnum: true },
        { domain: "Chanson Père & Fils", cuvee: "« Réserve du Bastion »", appellation: "AOC Bourgogne Chardonnay", year: 2023 },
        { domain: "Maison Jean Chartron", cuvee: "Vieilles Vignes", appellation: "AOC Bourgogne Chardonnay", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "Vieilles Vignes", appellation: "AOC Bourgogne Hautes-Côtes de Beaune", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "« Les Pierres Sèches »", appellation: "AOC Santenay", year: 2024 },
        { domain: "Maison Jean Chartron", appellation: "AOC Chassagne-Montrachet", year: 2024 },
        { domain: "Maison Jean Chartron", appellation: "AOC Puligny-Montrachet", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "« Folatières » 1er Cru", appellation: "AOC Puligny-Montrachet 1er Cru", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "« Clos de la Pucelle » 1er Cru Monopole", appellation: "AOC Puligny-Montrachet 1er Cru", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "« Clos du Cailleret » 1er Cru", appellation: "AOC Puligny-Montrachet 1er Cru", year: 2024 },
        { domain: "Maison Jean Chartron", appellation: "AOC Bâtard-Montrachet Grand Cru", year: 2024 },
        { domain: "Maison Jean Chartron", cuvee: "« Clos des Chevaliers » Grand Cru Monopole", appellation: "AOC Chevalier-Montrachet Grand Cru", year: 2024 },
      ],
    },
    {
      subregion: "Bourgogne — Côte Chalonnaise",
      wines: [
        { domain: "Chanson Père & Fils", appellation: "AOC Mercurey", year: 2022 },
        { domain: "Chanson Père & Fils", appellation: "AOC Rully", year: 2024 },
      ],
    },
    {
      subregion: "Bourgogne — Mâconnais",
      wines: [
        { domain: "Domaine Thévenard", cuvee: "Chardonnay", appellation: "AOC Bourgogne", year: 2023 },
        { domain: "Domaine Thévenard", cuvee: "« Marguerite »", appellation: "AOC Mâcon-Uchizy", year: 2023 },
        { domain: "Chanson Père & Fils", appellation: "AOC Mâcon Villages", year: 2023 },
        { domain: "Chanson Père & Fils", appellation: "AOC Viré-Clessé", year: 2023 },
        { domain: "Chanson Père & Fils", appellation: "AOC Pouilly-Fuissé", year: 2022 },
      ],
    },
    // === Autres régions ===
    {
      subregion: "Loire",
      wines: [
        { domain: "Domaine François Crochet — Sancerre", appellation: "AOC Sancerre", year: 2024 },
      ],
    },
    {
      subregion: "Provence",
      wines: [
        { domain: "Domaine Saint André de Figuière — Famille Combard", cuvee: "« Première »", appellation: "AOP Côtes de Provence", year: 2025, bio: true },
      ],
    },
    {
      subregion: "Alsace",
      wines: [
        { domain: "Domaine Jean-Marie Haag", cuvee: "« Les Encrines » · Riesling", appellation: "AOC Alsace Riesling", year: 2022 },
        { domain: "Domaine Jean-Marie Haag", cuvee: "Pinot Gris Grand Cru", appellation: "AOC Alsace Grand Cru Zinnkoepflé", year: 2023 },
        { domain: "Maison Trimbach", cuvee: "Réserve · Gewurztraminer", appellation: "AOC Alsace Gewurztraminer", year: 2017 },
      ],
    },
    // === Vins doux & moelleux ===
    {
      subregion: "Vins doux & moelleux",
      wines: [
        { domain: "Vignoble Alain Ignace", cuvee: "Muscat Blanc", appellation: "Beaumes-de-Venise", year: 2025 },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "Muscat", appellation: "Beaumes-de-Venise", year: 2023, bio: true },
        { domain: "Château La Tour Blanche", appellation: "AOC Sauternes · 1er Grand Cru Classé", year: 2022 },
      ],
    },
  ],

  rouge: [
    // === Vallée du Rhône — Sud ===
    {
      subregion: "Ventoux",
      wines: [
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Pied Roi »", appellation: "AOC Ventoux" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Ubac »", appellation: "AOC Ventoux" },
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Réserve du Peyreras »", appellation: "AOC Ventoux", year: 2023 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Tradition »", appellation: "AOP Ventoux", year: 2024, bio: true },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Cuvée Spéciale »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Les Essareaux »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Autrefois »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Vieilles Vignes »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Argile »", appellation: "AOP Ventoux", year: 2023 },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Instant Présent »", appellation: "AOP Ventoux", year: 2024, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Rien ne sert de courir »", appellation: "AOP Ventoux", year: 2023, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Ici, le temps s'arrête »", appellation: "AOP Ventoux", year: 2023, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Klemz »", appellation: "AOP Ventoux", year: 2022, bio: true },
        { domain: "Domaine Les Chancel — Mormoiron", cuvee: "« Le Récit »", appellation: "AOP Ventoux", year: 2020 },
      ],
    },
    {
      subregion: "Côtes du Rhône",
      wines: [
        { domain: "Domaine Talès — Entrechaux", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Adret »", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Versant Sud »", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Talès — Entrechaux", cuvee: "« Versant Sud Sélection »", appellation: "AOC Côtes du Rhône" },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« Terre de Safres »", appellation: "AOP Côtes du Rhône", year: 2024, bio: true },
        { domain: "Domaine Champ-Long — Entrechaux", cuvee: "« La Lauzerette »", appellation: "AOP Côtes du Rhône", year: 2023 },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "Cuvée traditionnelle", appellation: "AOC Côtes du Rhône", year: 2023, bio: true },
        { domain: "Coteaux des Travers — Rasteau", cuvee: "« Zouzou »", appellation: "AOC Côtes du Rhône", year: 2024, bio: true },
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "Cuvée traditionnelle", appellation: "AOC Côtes du Rhône", year: 2023, bio: true },
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "« Les Champauvins »", appellation: "AOC Côtes du Rhône", year: 2023, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Patience »", appellation: "AOP Côtes du Rhône", year: 2023, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Patience »", appellation: "AOP Côtes du Rhône", year: 2021, bio: true, magnum: true },
      ],
    },
    {
      subregion: "Côtes du Rhône Villages",
      wines: [
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Le Laurias »", appellation: "AOC CDR Villages Vaison-la-Romaine", year: 2020 },
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Cuvée Julien »", appellation: "AOC CDR Villages Séguret", year: 2022 },
        { domain: "Coteaux des Travers — Rasteau", cuvee: "« Les Lauzes »", appellation: "AOC CDR Villages Massif d'Uchaux", year: 2024, bio: true },
        { domain: "Coteaux des Travers — Rasteau", cuvee: "« Terra Rosea »", appellation: "AOC Cairanne", year: 2024, bio: true },
        { domain: "Coteaux des Travers — Rasteau", cuvee: "« Les Travès »", appellation: "AOC Rasteau", year: 2023, bio: true },
      ],
    },
    {
      subregion: "Vacqueyras",
      wines: [
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Le Pilon »", appellation: "AOC Vacqueyras", year: 2023 },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "Cuvée traditionnelle", appellation: "AOC Vacqueyras", year: 2024, bio: true },
        { domain: "Alain Jaume", cuvee: "« Grande Garrigue »", appellation: "AOC Vacqueyras", year: 2024, bio: true },
      ],
    },
    {
      subregion: "Gigondas",
      wines: [
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« Four Danuga »", appellation: "AOC Gigondas", year: 2022 },
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« La Grande Réserve »", appellation: "AOC Gigondas", year: 2021 },
        { domain: "Le Mas des Flauzières — Entrechaux", cuvee: "« La Grande Réserve »", appellation: "AOC Gigondas", year: 2022, magnum: true },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "Cuvée traditionnelle", appellation: "AOC Gigondas", year: 2023, bio: true },
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "« La Belle Cime »", appellation: "AOC Gigondas", year: 2023, bio: true },
        { domain: "Alain Jaume", cuvee: "« Terrasses de Montmirail »", appellation: "AOC Gigondas", year: 2021 },
      ],
    },
    {
      subregion: "Châteauneuf-du-Pape",
      wines: [
        { domain: "Domaine Grand Veneur — Alain Jaume", cuvee: "« Les Origines »", appellation: "AOC Châteauneuf-du-Pape", year: 2022, bio: true },
      ],
    },
    {
      subregion: "Beaumes-de-Venise",
      wines: [
        { domain: "Vignoble Alain Ignace", cuvee: "« Helvétien »", appellation: "AOC Beaumes-de-Venise", year: 2024, bio: true },
      ],
    },
    {
      subregion: "Luberon",
      wines: [
        { domain: "Domaine de Maslauris", cuvee: "« L'Inopiné »", appellation: "AOP Luberon", year: 2023, bio: true },
      ],
    },
    {
      subregion: "IGP & Vin de France",
      wines: [
        { domain: "Domaine d'Ouréa — Vacqueyras", cuvee: "« Tire Bouchon »", appellation: "IGP Vaucluse", year: 2025, bio: true },
        { domain: "Mas Oncle Ernest — Entrechaux", cuvee: "« Mieux vaut tard »", appellation: "Vin de France", year: 2022, bio: true },
        { domain: "Domaine Les Chancel — Mormoiron", cuvee: "« Le Rouge N°1 »", appellation: "IGP Vaucluse", year: 2023, bio: true },
      ],
    },
    // === Vallée du Rhône — Nord ===
    {
      subregion: "Vallée du Rhône — Nord",
      wines: [
        { domain: "Alain Jaume — « La Butte d'Or »", appellation: "AOC Saint-Joseph", year: 2025 },
        { domain: "Alain Jaume — « La Butte d'Or »", appellation: "AOC Crozes-Hermitage", year: 2023, bio: true },
        { domain: "Ogier Michel & Stéphane", cuvee: "« Mon Village »", appellation: "AOC Côte-Rôtie", year: 2021 },
      ],
    },
    // === Bourgogne ===
    {
      subregion: "Bourgogne — Côte de Nuits",
      wines: [
        { domain: "Domaine Amiot-Servelle — Chambolle-Musigny", appellation: "AOC Bourgogne Côte d'Or", year: 2023, bio: true },
        { domain: "Domaine Amiot-Servelle — Chambolle-Musigny", cuvee: "Village", appellation: "AOC Chambolle-Musigny", year: 2023, bio: true },
        { domain: "Jouan Olivier", cuvee: "Vieilles Vignes", appellation: "AOC Bourgogne Hautes-Côtes de Nuits", year: 2023 },
        { domain: "Domaine Hubert Lignier", cuvee: "« Symbiose »", appellation: "AOC Bourgogne Pinot Noir", year: 2022 },
        { domain: "Domaine Hubert Lignier", cuvee: "Grand Cru", appellation: "AOC Charmes-Chambertin", year: 2021 },
      ],
    },
    {
      subregion: "Bourgogne — Côte de Beaune",
      wines: [
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "Pinot Noir", appellation: "AOC Bourgogne Côte d'Or", year: 2023 },
        { domain: "Rodolphe Demougeot — Meursault", appellation: "AOC Bourgogne Hautes-Côtes de Beaune", year: 2023 },
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "« Les Clous »", appellation: "AOC Auxey-Duresses", year: 2023 },
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "« Les Beaux Fougets »", appellation: "AOC Beaune", year: 2023 },
        { domain: "Rodolphe Demougeot — Meursault", cuvee: "« Les Vignots »", appellation: "AOC Pommard", year: 2023 },
        { domain: "Baillot Arnaud", cuvee: "« La Montagne »", appellation: "AOC Bourgogne", year: 2022 },
        { domain: "Baillot Arnaud", cuvee: "« À Ma Fille Mahaut »", appellation: "AOC Pernand-Vergelesses", year: 2022 },
        { domain: "Domaine Larue — Saint-Aubin", cuvee: "Village", appellation: "AOC Aloxe-Corton", year: 2023 },
        { domain: "Pierre & J-B Lebreuil", cuvee: "Village", appellation: "AOC Savigny-lès-Beaune", year: 2024 },
        { domain: "Domaine Hubert Lignier", cuvee: "Village", appellation: "AOC Monthélie", year: 2022 },
        { domain: "Domaine Arthur Gras — Saint-Romain", cuvee: "Vieilles Vignes", appellation: "AOC Monthélie", year: 2023 },
        { domain: "Domaine Arthur Gras — Saint-Romain", cuvee: "« Les Vergelesses » 1er Cru", appellation: "AOC Savigny-lès-Beaune 1er Cru", year: 2023 },
        { domain: "Domaine Alain Gras — Saint-Romain", appellation: "AOC Saint-Romain", year: 2023 },
        { domain: "Domaine Alain Gras — Saint-Romain", appellation: "AOC Saint-Romain", year: 2023, magnum: true },
        { domain: "Chanson Père & Fils", cuvee: "« Réserve du Bastion »", appellation: "AOC Bourgogne Pinot Noir", year: 2023 },
        { domain: "Chanson Père & Fils", cuvee: "Village", appellation: "AOC Auxey-Duresses", year: 2022 },
        { domain: "Chanson Père & Fils", cuvee: "« Les Vergelesses » 1er Cru", appellation: "AOC Pernand-Vergelesses 1er Cru", year: 2021 },
        { domain: "Chanson Père & Fils", cuvee: "« Les Teurons » 1er Cru", appellation: "AOC Beaune 1er Cru", year: 2021 },
        { domain: "Chanson Père & Fils", cuvee: "« Clos du Roi » 1er Cru", appellation: "AOC Beaune 1er Cru", year: 2023 },
        { domain: "Chanson Père & Fils", cuvee: "« Clos des Marconnets » 1er Cru", appellation: "AOC Beaune 1er Cru", year: 2023 },
        { domain: "Maison Jean Chartron", cuvee: "« Cuvée Eugénie Dupard »", appellation: "AOC Bourgogne Pinot Noir", year: 2024 },
      ],
    },
    {
      subregion: "Bourgogne — Côte Chalonnaise",
      wines: [
        { domain: "Chanson Père & Fils", cuvee: "Village", appellation: "AOC Mercurey", year: 2022 },
        { domain: "Chanson Père & Fils", cuvee: "Village", appellation: "AOC Givry", year: 2022 },
      ],
    },
    // === Autres régions ===
    {
      subregion: "Loire",
      wines: [
        { domain: "Domaine François Crochet — Sancerre", appellation: "AOC Sancerre", year: 2023 },
      ],
    },
    {
      subregion: "Provence",
      wines: [
        { domain: "Domaine Saint André de Figuière — Famille Combard", cuvee: "« Première »", appellation: "AOP Côtes de Provence", year: 2024 },
      ],
    },
    {
      subregion: "Alsace",
      wines: [
        { domain: "Maison Trimbach", cuvee: "Réserve · Pinot Noir", appellation: "AOC Alsace Pinot Noir", year: 2023 },
      ],
    },
    {
      subregion: "Corse",
      wines: [
        { domain: "Domaine Novella", cuvee: "« Tradizione »", appellation: "AOP Patrimonio", year: 2023 },
        { domain: "Domaine Novella", cuvee: "« Alba Rossa »", appellation: "AOP Patrimonio", year: 2021 },
      ],
    },
  ],
};

// Display order of color tabs
export const WINE_COLOR_ORDER = ["champagne", "rose", "blanc", "rouge"];

// Visual accent color per tab
export const WINE_COLOR_ACCENT = {
  champagne: "#C9B173",
  rose: "#D89B7A",
  blanc: "#A5C4D4",
  rouge: "#8B3A3A",
};
